import { post as _post } from '../../../utils/fetcher'
import { safeGet } from '../../../utils/safeGet'

export default {
  namespaced: true,

  state: {
    pagination: {
      perPage: 25,
      currentPage: 1,
      items: 0,
    },
    sortingValue: '-MonitoringDate',
    searchBarValue: '',
    monitoringsList: [],
  },

  mutations: {
    setPagination(state, data) {
      state.pagination = data
    },
    setSortingValue(state, data) {
      state.sortingValue = data
    },
    setSearchBarValue(state, data) {
      state.searchBarValue = data
    },
    setPaginationPerPage(state, data) {
      state.pagination.perPage = data
    },
    setPaginationCurrentPage(state, data) {
      state.pagination.currentPage = data
    },
    setMonitoringsList(state, data) {
      state.monitoringsList = data
    },
  },

  actions: {
    loadMonitoringsList({ commit, getters, dispatch }) {
      dispatch('scoringProfilesCommon/setLoading', true, { root: true })
      const payload = {
        Sf: getters.getSearchBarValue,
        Page: getters.getPagination.currentPage,
        Size: getters.getPagination.perPage,
        Sort: getters.getSortingValue,
      }
      return new Promise((resolve, reject) => {
        _post('/api/scoringMonitoring/list', payload)
          .then((data) => {
            if (data.paging) {
              const perPage =
                data.paging.pageSize && data.paging.pageSize > 24 ? data.paging.pageSize : getters.getPagination.perPage

              commit('setPagination', {
                perPage: perPage,
                currentPage: data.paging.pageIndex,
                items: data.paging.totalItems,
              })
            }

            if (Array.isArray(data.scoringMonitoringList)) {
              commit('setMonitoringsList', data.scoringMonitoringList)
            } else {
              commit('setMonitoringsList', [])
            }

            resolve()
          })
          .catch((err) => {
            reject(err)
          })
          .finally(() => {
            dispatch('scoringProfilesCommon/setLoading', false, { root: true })
          })
      })
    },

    launchMonitoring({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        _post('/api/scoringMonitoring/launch', payload)
          .then((data) => {
            dispatch('loadMonitoringsList')
            // Carries a `notice` when the launch went through but had nothing to monitor.
            resolve(data)
          })
          .catch((err) => reject(err))
      })
    },

    archiveMonitoring({ dispatch }, id) {
      const payload = {
        monitoringId: id,
      }

      return new Promise((resolve, reject) => {
        _post('/api/scoringMonitoring/archive', payload)
          .then(() => {
            dispatch('loadMonitoringsList')
            resolve()
          })
          .catch((err) => reject(err))
      })
    },

    deleteMonitoring({ dispatch }, id) {
      const payload = {
        monitoringId: id,
      }

      return new Promise((resolve, reject) => {
        _post('/api/scoringMonitoring/delete', payload)
          .then(() => {
            dispatch('loadMonitoringsList')
            resolve()
          })
          .catch((err) => reject(err))
      })
    },

    renameMonitoring({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        _post('/api/scoringMonitoring/rename', payload)
          .then(() => {
            dispatch('loadMonitoringsList')
            resolve()
          })
          .catch((err) => reject(err))
      })
    },

    resetState({ state }) {
      state.pagination = {
        perPage: 25,
        currentPage: 1,
        items: 0,
      }
      state.sortingValue = ''
      state.searchBarValue = ''
      state.monitoringsList = []
    },
  },

  getters: {
    getPagination: (state) => {
      return safeGet(() => state.pagination, {
        perPage: 25,
        currentPage: 1,
        items: 0,
      })
    },
    getSortingValue: (state) => {
      return safeGet(() => state.sortingValue, '')
    },
    getSearchBarValue: (state) => {
      return safeGet(() => state.searchBarValue, '')
    },
    getMonitoringsList: (state) => {
      return safeGet(() => state.monitoringsList, [])
    },
  },
}
